import type { FaireProductEntity } from "../../entity_types/product";

export const p_b35a4dgfx4: FaireProductEntity = {
  token: "p_b35a4dgfx4",
  type: "product",
  name: "CHRISTMAS CHECK PLAID WOVEN HOLIDAY MIDI DRESS",
  brandToken: "b_emnha4uv86",
  brandName: "So Me",
  imageUrl:
    "https://cdn.faire.com/fastly/425ace392af86c613cff5ef3a90e409613497b8b119a7b6659787048ab1b6103.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce13ff31e3787cbfcd173354d8d5da3720ff71e31f8929302a43650ccec453de.jpeg",
    "https://cdn.faire.com/fastly/75ce5f978644c5521ace1202cd4aaf82c79ad8152ad55b07dbe039a3af960210.jpeg",
    "https://cdn.faire.com/fastly/ef2a9532ac4c943a80083ac3e748b6e453ebe30007823bfae4db32acfa24fddc.jpeg",
    "https://cdn.faire.com/fastly/daa38ca19ff6e1ee48a7e6527ddb7963b1c8f6898f04f2909ce04bfdeb759e38.jpeg",
    "https://cdn.faire.com/fastly/1bcdb470771bcda6f07eadb933fc76a65b3894a2e59fb2abfec5aef7a7f6a922.jpeg",
    "https://cdn.faire.com/fastly/c08915f5f13d49a7a342616627f91f93834ec663951e000dc3023f36531ab16b.jpeg",
    "https://cdn.faire.com/fastly/625e894616a5f1ef4e5197fc9e2bcd617633c24f0d0a9ab18fbe214345411e61.jpeg",
    "https://cdn.faire.com/fastly/7c9ff06f92c77b5cbd6eeeafd54f9f610963a0a7692383e162152b59fdd5e446.jpeg",
    "https://cdn.faire.com/fastly/ac92d11223154a0518eb55dd966fc39e59cc72849207c834334003eedf47f51b.jpeg",
    "https://cdn.faire.com/fastly/ef8d0578fce257c868e7f1ebb7e82abd8107e2740efc985f7a7406d8e43ddc4f.jpeg",
    "https://cdn.faire.com/fastly/711226f9dbbca905c2387f4ccd4901800b4a8f580c949b10babfb415d8110182.jpeg",
    "https://cdn.faire.com/fastly/f767c525c0767c6dcf6fae7fe6dba4e88f79f323d10dae972d6dbbca2e137bff.jpeg",
    "https://cdn.faire.com/fastly/7023088abe1a72ea306c16c10865a79d82f9c7f4905dba0965abbbbc1f9f97b5.jpeg",
    "https://cdn.faire.com/fastly/bddd89a2e46e18f74ddf588220768ab7ee01b98c9eccd7b6d2e93c4a6e547d15.jpeg",
    "https://cdn.faire.com/fastly/72d383830259daa6a4bbe5e2d3dfa156ba724ba40113a2402e31086b9bbda3b5.jpeg",
    "https://cdn.faire.com/fastly/27ec010ec4ab56f5ae292c48900b15a00a9de97fbd5d214d9572f8b039c9f562.jpeg",
    "https://cdn.faire.com/fastly/367579cbd5e4d2b31feb4ecb45ed89980bbe4d45f335c3ac0e165d67353711bd.jpeg",
    "https://cdn.faire.com/fastly/a2032550a539c5b9a0bdef2d1fae8fcf38b3cfb7b9bb1105b3a1c61009385dea.jpeg",
    "https://cdn.faire.com/fastly/62941ed457b63a2221d1274cb57a60f89c86ba04a3e4c5323c9bf2120b2299ec.jpeg",
    "https://cdn.faire.com/fastly/c18acc3df605eda988c65461f7fb7970c7381da0cd0c37188ebd218af3049b0c.jpeg",
    "https://cdn.faire.com/fastly/bb764529d186ce7d37f0796b5aa42856b69d259bf0be1866a198791bf778b062.jpeg",
    "https://cdn.faire.com/fastly/b0c87bda7d135b5ddf833f07c483b007c67eab925f985acc84e7c2e861149a6d.jpeg",
    "https://cdn.faire.com/fastly/f2fcf166bafa941f2472a8cfc63622940253b43b9b4ea486d42669e93c6fbfac.jpeg",
    "https://cdn.faire.com/fastly/33c23407d0ededee753bbdd468e372cc2079fe65940f3ab5f3a10b5b6df85c7b.jpeg",
    "https://cdn.faire.com/fastly/271b167286ff0237c686b8a6290489fa13e482689949927d88d83109f119efba.jpeg",
    "https://cdn.faire.com/fastly/38ea768ea392effbf660c8701fc4c38e0f9146defdc29c8ebad11e929e7ea968.jpeg",
  ],
  priceDollars: 174.65,
  description:
    "Step into the festive season with this charming woven holiday midi dress. Featuring a timeless check plaid print, it offers a beautifully structured silhouette. The fitted bodice is perfectly complemented by wide, adjustable ribbon tie straps that add a delicate, romantic touch to the shoulders. A softly defined waist flows gracefully into a voluminous skirt, finished with a stunning tiered ruffle hem. This piece flawlessly combines classic patterns with feminine, elegant details for an unforgettable seasonal look.",
  tags: [],
  msrpDollars: 349.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:25.837Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
